export const ADD_TO_BASKET_ERROR = 'Something went wrong. Please try again.';
